import type { Data } from './Data';

export { Results as LastAddedItemMethod } from '@ori-events/loyalty-dialog-result';

export type {
  BasketOffer,
  BasketOfferBenefit,
  BasketOfferConcept,
  BasketOfferConceptBenefit,
  BasketOfferItem,
  BasketOfferProduct,
  BasketOfferPurchase,
} from './BasketOffer';
export { BasketOfferTypes } from './BasketOffer';

export type { GodModeOutput, GodModeOutputItem } from './GodModeOutput';

export type { LastAddedItem } from './LastAddedItem';

export type { Referral } from './Referral';

export type {
  ShoppingBag,
  ShoppingBagBalance,
  ShoppingBagDiscount,
  ShoppingBagSubscriptions,
  ShoppingBagSubscriptionsPackages,
  ShoppingBagVipLoyalty,
} from './ShoppingBag';

export type {
  DiscountMessage,
  OriginalProduct,
  Replacement,
  ReplacementItem,
  ShoppingBagItem,
  ShoppingBagItemProductFlag,
} from './ShoppingBagItem';

export type { ShoppingBagOffer } from './ShoppingBagOffer';

export type { ShoppingMessage, ProgressBarItems } from './ShoppingMessage';

export type { ShoppingNotification } from './ShoppingNotification';
export { ShoppingNotificationType } from './ShoppingNotification';

export type {
  EndConsumerOrderItem,
  PendingEndConsumerOrder,
  ShippingOffer,
  SliderModel,
  UnitDataCollection,
  UnitDataCollectionBeautyConsultant,
  UnitDataCollectionCommon,
  UnitDataCollectionDelivery,
  UnitDataCollectionDonationUnit,
  UnitDataCollectionEndConsumerPendingOrder,
  UnitDataCollectionOffer,
  UnitDataCollectionPreOrderTargetUnit,
  UnitDataCollectionSectionUnit,
  UnitDataCollectionSpecialOffer,
  UnitDataCollectionVouchers,
  UnitDataCollectionWellnessSelling,
  UnitDataOffer,
  UnitDataOfferItem,
} from './UnitDataCollection';

export const Test = 'TEST';
export const Name = 'basket-updated';
type EventName = typeof Name;

export const BasketUpdatedEvent: EventName = Name;
export type { Data };

export interface Event extends CustomEvent<Data> {
  type: EventName;
}

export default Event;

declare global {
  interface WindowEventMap {
    [Name]: Event;
  }
}
